module.exports = __webpack_public_path__ + "42be9a6be17d9beb8f7ea1088e51cd8d.MP3";